import { useCallback } from 'react'
import { useLatestLoad } from '../../hooks/useLatestLoad'
import { fetchAgenda } from '../adminApi'
import { isIsoDate } from '../../core/format/dates'
import type { AgendaRange } from '../../core/types/agenda'
import type { RequestOptions } from '../../core/types/backend'

const EMPTY: AgendaRange = { staff: [], appointments: [], blocks: [] }

/**
 * De afspraken en blokkades van één dag, voor `TimeChoice` buiten de agenda (klantdossier).
 * Alleen het antwoord op de laatste datum telt (useLatestLoad), dus snel wisselen is veilig.
 */
export function useAgendaDay(date: string) {
  const load = useCallback((opts: RequestOptions) => (isIsoDate(date) ? fetchAgenda(date, date, opts) : Promise.resolve(EMPTY)), [date])
  const { data, status } = useLatestLoad(load)
  return { appointments: data?.appointments ?? [], blocks: data?.blocks ?? [], status }
}
